
export default {
  layout: "ContactUsLayout",
  data() {
    return {
      title: "Contact Us | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "contactus",
          name: "contactus",
          content:
            "Bikeflights is an easy-to-use bicycle shipping service and a supplier of easy-to-pack bike shipping boxes. You get low costs, excellent service and on-time delivery with every shipment as part of our Best Way Guarantee.",
        },
      ],
      script: [
        {
          hid: "InSync.Ai",
          src: "/tracking/inSyncAi.js",
          async: true,
          defer: true,
          body: true,
        },
      ],
    };
  },
  computed: {
    inSyncAiEnvSelected() {
      return this.$config.inSyncAi.env === "production"
        ? "prod"
        : this.$config.inSyncAi.env === "staging"
        ? "staging"
        : "dev";
    },
  },
  fetchOnServer: false,
};
